import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import { DoctorData, ApproveData, rejected, RevokeData } from '../reduxactions/adminactions/AviewDoctorActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button';
import { Stepper } from 'primereact/stepper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

export const AdminViewDoctor = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const stepperRef = useRef(null);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("DoctorID") as any);
    }, [location]);
    const { DoctorID } = useParams();
    console.log(DoctorID);
    const doctordata = useSelector((state: RootState) => state.viewdoctor.data);
    // const hospitaldata = useSelector((state: RootState) => state.viewdoctor.hospitaldata);
    const status = doctordata[0]?.status;
    console.log(status, "status")
    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(DoctorData(DoctorID) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const toast = useRef<Toast>(null);
    const [approveDilog, setApproveDilog] = useState(false);
    const [category, setCategory] = useState('');
    const ApproveDoctor = async () => {
        try {
            const payload = { q: 7, doctorid: DoctorID, plan: category };
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync();
            setApproveDilog(false);
            setCategory('');
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: response });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [rejectDilog, setRejectDilog] = useState(false);
    const [rejectreason, setReason] = useState('');
    const toast1 = useRef<Toast>(null);

    const RejectDoctor = async () => {
        try {
            const payload = { q: 5, doctorid: DoctorID, reason: rejectreason };
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync();
            setRejectDilog(false);
            setReason('');
            if (toast1.current) {
                toast1.current.show({ severity: 'error', detail: response });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const toast2 = useRef<Toast>(null);

    const RevokeDoctor = async () => {
        try {
            const response = await dispatch(RevokeData(DoctorID) as any);
            fetchDataAsync();
            setRejectDilog(false);
            if (toast2.current) {
                toast2.current.show({ severity: 'success', detail: response });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);

    const [categorydata, setCategoryData] = useState<[]>([]);


    const getCategory = async () => {
        try {
            const payload = {};
            const apiname = Admin_API.cat_API;
            const data1 = await LoginService.getData(apiname, payload);
            setCategoryData(data1);
        } catch (error) {

        }
    };

    const [uplodata, setuplodata] = useState<[]>([]);


    const getuploddata = async () => {
        try {
            const payload = { uid: DoctorID };
            const apiname = Admin_API.upload_API;
            const data1 = await LoginService.getData(apiname, payload);
            setuplodata(data1);
        } catch (error) {

        }
    };
    const [selectedImage, setSelectedImage] = useState('');
    const [ViewDilog, setViewDilog] = useState(false);
    const assignData = useRef({ image: '' });
    const viewPage = (rowData: any) => {
        assignData.current = { image: rowData.image };
        console.log(assignData.current, "id");
        setViewDilog(true);
    };
    useEffectOnce(() => {
        getCategory();
        getuploddata();
    }, [dispatch]);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewadmindoctorlist.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">

                                    <div className="col-9">
                                        <h1>Profile</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>

                                </div>
                            </div>
                        </section >
                        <section className="content">



                            {doctordata.map((response: any) =>
                                <>

                                    <div>
                                        <Stepper ref={stepperRef}>


                                            {/* <TabMenu> */}

                                            <StepperPanel header="Personal Info">
                                                <div className="grid">

                                                    <div className="col-3">
                                                        <Panel style={{ width: "100%" }}>
                                                            <a key={response.id}>
                                                                <img src={response.photo} style={{ width: '110px', height: '90px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />
                                                            </a>
                                                            <h3 className="profile-username text-center mt-3">{response.firstName}</h3>
                                                            <br></br>
                                                            <h3 style={{ color: '#6c757d', fontWeight: '400' }}>Doctor</h3>


                                                        </Panel>
                                                    </div>



                                                    <div className="col-9">
                                                        <Card >
                                                            <div className="col-8">
                                                                <h1>DOCTOR(**{response.status}**)</h1>
                                                            </div>
                                                            <Panel header="Personal Details" toggleable  >
                                                                <div className='grid'>
                                                                    <div className="col-6">


                                                                        <div className="col-3">
                                                                            <label htmlFor="fname" className="block text-900 font-medium ">First Name</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="fname" type="text" disabled className="w-full mb-3" value={response.firstName} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="lname" className="block text-900 font-medium">Last Name</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="lname" type="text" disabled className="w-full mb-3" value={response.lastName} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="email" type="text" className="w-full mb-3" disabled value={response.email} />
                                                                        </div>
                                                                        <div className="col-5">
                                                                            <label htmlFor="email" className="block text-900 font-medium ">ID Card Number</label>

                                                                        </div>
                                                                        <div className="col-12">
                                                                            {/* <Dropdown value={.gender}  options={genderoptions} optionLabel="label" optionValue='value' placeholder="Select Gender" className="w-full mb-3" /> */}
                                                                            <InputText id="email" type="text" disabled className="w-full mb-3" value={response.idcard} />

                                                                        </div>


                                                                        <div className="col-3">
                                                                            <label htmlFor="phone" className="block text-900 font-medium ">Date of Birth</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText
                                                                                type="tel"
                                                                                value={response.dob}
                                                                                disabled
                                                                                placeholder="Enter Phone Number"
                                                                                className="w-full mb-3"
                                                                            />
                                                                        </div>

                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Gender</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.gender} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">LinkedIn Profile </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.firstName} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Phone Number </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.phone} />
                                                                        </div>

                                                                        <div className="col-5">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Mobile (WhatsApp) </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.mob} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Skype ID*</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.skype} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <div className="col-3">
                                                                            <label htmlFor="add" className="block text-900 font-medium ">Fax No</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="add" type="text" disabled className="w-full mb-3" value={response.fax} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="add" className="block text-900 font-medium">Speciality</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="city" type="text" disabled className="w-full mb-3" value={response.specialty} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="state" className="block text-900 font-medium ">Languages</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="state" type="text" disabled className="w-full mb-3" value={response.language} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="pincode" className="block text-900 font-medium ">Door No</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.dno} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">Street</label>
                                                                        </div>
                                                                        <div className="col-12">

                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.street} />



                                                                        </div>

                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">City</label>
                                                                        </div>
                                                                        <div className="col-12">

                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.city} />



                                                                        </div>

                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">ZIP</label>
                                                                        </div>
                                                                        <div className="col-12">

                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.zip} />
                                                                        </div>

                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">Country</label>
                                                                        </div>
                                                                        <div className="col-12">

                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.country} />



                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">State</label>
                                                                        </div>
                                                                        <div className="col-12">

                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.statename} />

                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">Reject Reasons</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.reject} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="country" className="block text-900 font-medium ">Category</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.plan} />
                                                                        </div>

                                                                    </div>


                                                                </div>
                                                            </Panel>
                                                            <br></br>
                                                            <div className="row" style={{ marginLeft: '100px' }}>
                                                                {status !== 'REJECTED' &&  status !== 'REGISTERED' &&  (
                                                                    <Button className='mr-3' severity="danger" label="Reject" rounded onClick={() => setRejectDilog(true)} />


                                                                )}

                                                                {status !== 'REVOKE' &&  status !== 'REGISTERED' &&  (
                                                                    <Button className='mr-3' severity="info" label="Revoke" rounded onClick={RevokeDoctor} />

                                                                )}

                                                                {status !== 'APPROVED' && status !== 'REGISTERED' &&  (
                                                                    <Button className='mr-1' severity="success" label="Approve" rounded onClick={() => setApproveDilog(true)} />
                                                                     
                                                                )}
                                                                {/*
                                                                 * Author: Anuradha ,Date: 2026-02-05 
                                                                 * Description: Register stage lo vunnapudu  approve reject vundakudadhu
                                                                 */}
                                                                
                                                                
                                                            </div>

                                                        </Card>

                                                    </div>
                                                </div>
                                            </StepperPanel>

                                            <StepperPanel header="Hospital Info">
                                                <div className="grid">

                                                    <div className="col-3">
                                                        <Panel style={{ width: "100%" }}>
                                                            <a key={response.id}>
                                                                <img src={response.photo} style={{ width: '110px', height: '90px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />
                                                            </a>
                                                            <h3 className="profile-username text-center mt-3">{response.firstName}</h3>
                                                            <br></br>
                                                            <h3 style={{ color: '#6c757d', fontWeight: '400' }}>Doctor</h3>


                                                        </Panel>
                                                    </div>




                                                    <div className="col-9">

                                                        <Panel header="Personal Details" toggleable  >
                                                            <div className='grid'>
                                                                <div className="col-6">


                                                                    <div className="col-3">
                                                                        <label htmlFor="fname" className="block text-900 font-medium ">Hospital Name</label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="fname" type="text" disabled className="w-full mb-3" value={response.hospitalname} />
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <label htmlFor="lname" className="block text-900 font-medium">Hospital Prefix</label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="lname" type="text" disabled className="w-full mb-3" value={response.hospitalprefix} />
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="email" type="text" className="w-full mb-3" disabled value={response.hemail} />
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="email" className="block text-900 font-medium ">Phone</label>

                                                                    </div>
                                                                    <div className="col-12">
                                                                        {/* <Dropdown value={.gender}  options={genderoptions} optionLabel="label" optionValue='value' placeholder="Select Gender" className="w-full mb-3" /> */}
                                                                        <InputText id="email" type="text" disabled className="w-full mb-3" value={response.hphone} />

                                                                    </div>


                                                                    <div className="col-2">
                                                                        <label htmlFor="phone" className="block text-900 font-medium ">Address</label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText
                                                                            type="tel"
                                                                            value={response.address}
                                                                            disabled
                                                                            placeholder="Enter Phone Number"
                                                                            className="w-full mb-3"
                                                                        />
                                                                    </div>

                                                                    <div className="col-1">
                                                                        <label htmlFor="cardno" className="block text-900 font-medium ">City</label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hcity} />
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="cardno" className="block text-900 font-medium ">State </label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hcountry} />
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="cardno" className="block text-900 font-medium ">Country </label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hcountry} />
                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="cardno" className="block text-900 font-medium ">Pincode</label>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hpincode} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Panel>
                                                        <br></br>


                                                    </div>
                                                </div>

                                            </StepperPanel>


                                        </Stepper>


                                    </div>


                                </>
                            )}

                        </section>

                    </div>
                </div>
            </div>
            <section className="content" style={{ marginLeft: '335px', marginTop: '-20px' }}>
                <div className="grid">
                    <div className="col-2"></div>
                    <div className="col-8">
                        <div className="card card-primary">
                            <Card title="" style={{ width: '122%' }}>
                                <Panel header="View Documents" style={{ width: '100%' }} toggleable>

                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content">
                                        </div>
                                        <DataTable value={uplodata} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="docname" sortable header="Document Title"></Column>
                                            <Column header="Operation" body={(rowData) => (
                                                <>
                                                    <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewPage(rowData)} />
                                                </>
                                            )} />
                                        </DataTable>
                                    </div>
                                </Panel>
                            </Card>
                        </div>

                    </div>
                    <div className="col-1"></div>
                </div>
            </section>
            <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
                <div className="modal-header">
                </div>
                <div className="modal-body">
                    {uplodata.map((response: any, index: number) =>
                        <div key={index}>
                            <img src={response.image} alt="Doc" width="100%" height="auto" />
                        </div>
                    )}
                </div>
            </Dialog>
            <Dialog header="Reject Doctor" style={{ width: '38vw' }} visible={rejectDilog} onHide={() => setRejectDilog(false)}>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">
                            Reason for rejection:
                        </label>
                    </div>
                    <div className="col-6">
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            type="text"
                            value={rejectreason}
                            name="Enter Reason"
                            placeholder="Enter Reason"
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </div>
                </div>
                <div className="p-d-flex p-jc-between">
                    <Button label="Close" onClick={() => setRejectDilog(false)} severity="secondary" />
                    <Button label="Reject Doctor" security='info' onClick={RejectDoctor} style={{ marginLeft: '10px', float: 'right' }} />
                </div>
            </Dialog>
            <Dialog header="Approve Doctor" style={{ width: '38vw' }} visible={approveDilog} onHide={() => setApproveDilog(false)}>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">
                            Doctor Category:
                        </label>
                    </div>
                    <div className="col-6">
                        <Dropdown id="country" value={category} className="w-full mb-3" onChange={(e: DropdownChangeEvent) => setCategory(e.value)} options={categorydata} optionLabel="Category" optionValue="PlanID" placeholder="Select a Category" />
                    </div>
                </div>
                <div className="p-d-flex p-jc-between">
                    <Button label="Close" onClick={() => setApproveDilog(false)} severity="secondary" />
                    <Button label="Approve Doctor" security='success' onClick={ApproveDoctor} style={{ marginLeft: '10px', float: 'right' }} />
                </div>
            </Dialog>

            <Toast ref={toast1} ></Toast>
            <Toast ref={toast} ></Toast>
            <Toast ref={toast2} ></Toast>


        </div>
    )
}
